import dayjs from "dayjs";
import * as NotificationsProvider from "../Provider/NotificationsProvider";

export const notificationsList = async () => {
    const res = await NotificationsProvider.getNotificationsList();
    const notifications = res.data.results;
    const grouped = {};
    notifications.forEach((item) => {
        const dateKey = dayjs(item.created_at).format("YYYY-MM-DD");
        if (!grouped[dateKey]) {
            grouped[dateKey] = {list: [], newNotificationsCount: 0};
        }
        if (item.is_read === false) {
            grouped[dateKey].list.unshift({
                id: item.id,
                image: item.sender_profile.user.profile.avatar,
                title: item.title,
                description: item.message,
                is_read: item.is_read,
                created_at: dayjs(item.created_at).format("HH:mm"),
                sender_profile: item.sender_profile.user.username,
            });
            grouped[dateKey].newNotificationsCount++;
        } else {
            grouped[dateKey].list.push({
                id: item.id,
                image: item.sender_profile.user.profile.avatar,
                title: item.title,
                description: item.message,
                is_read: item.is_read,
                created_at: dayjs(item.created_at).format("HH:mm"),
                sender_profile: item.sender_profile.user.username,
            });
        }
    });
    const formatted = Object.entries(grouped).map(
        ([date, {list, newNotificationsCount}]) => ({
            id: list[0].id,
            today_new_notifications_count: newNotificationsCount,
            date: dayjs(date).format("DD.MM.YYYY"),
            list,
        })
    );
    return formatted;
};

export const notificationDetails = async (id) => {
    return await NotificationsProvider.getNotificationDetails(id).then((res) => {
        return res.data;
    });
};

export const notificationsStats = async () => {
    return await NotificationsProvider.getNotificationsStats().then((res) => {
        return res.data;
    });
};

export const notificationsMarkedRead = async (payload) => {
    return await NotificationsProvider.postNotificationsMarkedRead(payload).then(
        (res) => {
            return res.data;
        }
    );
};

export const notificationsMarkedReadAll = async () => {
    return await NotificationsProvider.postNotificationsMarkedReadAll().then(
        (res) => {
            return res.data;
        }
    );
};

export const notificationsUnreadCount = async () => {
    return await NotificationsProvider.getNotificationsUnreadCount().then((res) => {
        return res.data.unread_notifications
    });
};